import { Link } from 'react-router-dom'
import type { ArticleData } from '../types'
import { formatArabicDate } from '../lib/format'
import { ArrowLeft, CalendarIcon } from './Icons'

export function ArticleCard({ article, variant = 'default' }: { article: ArticleData; variant?: 'default' | 'home' }) {
  return (
    <article className={`article-card ${variant === 'home' ? 'home-article-card' : ''}`}>
      <Link className="article-image" to={`/${article.slug}`}>
        <img src={article.image} alt={article.title} loading={variant === 'home' ? 'eager' : 'lazy'} />
      </Link>
      <div className="article-card-body">
        {variant !== 'home' && <div className="article-date"><CalendarIcon /> {formatArabicDate(article.date)}</div>}
        <h3><Link to={`/${article.slug}`}>{article.title}</Link></h3>
        {article.excerpt && <p>{article.excerpt}</p>}
        {variant !== 'home' && <Link className="text-link" to={`/${article.slug}`}>اقرأ التفاصيل <ArrowLeft /></Link>}
      </div>
    </article>
  )
}
